"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
export const SUBMISSION_STALL_MS = 20_000;

/**
 * Reports whether the current pending submission has run past `stallMs`
 * without settling. React transitions cannot be cancelled, so callers use
 * this to surface an error and re-enable the submit control instead of
 * leaving the form disabled indefinitely.
 */
export function useStalledSubmission(isPending, t0) {
  const $ = _c(4);
  const stallMs = t0 === undefined ? SUBMISSION_STALL_MS : t0;
  const [hasStalled, setHasStalled] = useState(false);
  let t1;
  let t2;
  if ($[0] !== isPending || $[1] !== stallMs) {
    t1 = () => {
      if (!isPending) {
        return;
      }
      const timer = setTimeout(() => setHasStalled(true), stallMs);
      return () => {
        clearTimeout(timer);
        setHasStalled(false);
      };
    };
    t2 = [isPending, stallMs];
    $[0] = isPending;
    $[1] = stallMs;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return isPending && hasStalled;
}